import { Controller } from "@hotwired/stimulus"

// Action Config Controller
// Manages dynamic config fields for action nodes in the workflow canvas
export default class extends Controller {
  static targets = [
    "typeSelect",
    "configContainer",
    "addToBoardTemplate",
    "assignVerticalTemplate",
    "updateFieldTemplate",
    "sendWebhookTemplate",
    "startResearchTemplate",
    "runWebsiteCrawlerTemplate",
    "lookupCompaniesHouseTemplate",
    "runCompanySearchTemplate",
    "enqueueEnrichmentTemplate"
  ]

  connect() {
    // Only populate config from template if:
    // 1. A type is selected AND
    // 2. The config container is empty (server didn't render content)
    // This preserves server-rendered form fields that have saved values
    if (this.hasTypeSelectTarget &&
        this.typeSelectTarget.value &&
        this.hasConfigContainerTarget &&
        this.configContainerTarget.children.length === 0) {
      this.showConfigForType(this.typeSelectTarget.value)
    }
  }

  typeChanged(event) {
    const actionType = event.target.value
    this.showConfigForType(actionType)
  }

  showConfigForType(actionType) {
    // Clear current config
    this.configContainerTarget.innerHTML = ''

    if (!actionType) return

    // Map action types to template names
    const templateMap = {
      'add_to_board': 'addToBoardTemplate',
      'assign_vertical': 'assignVerticalTemplate',
      'update_field': 'updateFieldTemplate',
      'send_webhook': 'sendWebhookTemplate',
      'start_research': 'startResearchTemplate',
      'run_website_crawler': 'runWebsiteCrawlerTemplate',
      'lookup_companies_house': 'lookupCompaniesHouseTemplate',
      'run_company_search': 'runCompanySearchTemplate',
      'enqueue_enrichment': 'enqueueEnrichmentTemplate'
    }

    const templateName = templateMap[actionType]
    if (templateName && this[`has${this.capitalize(templateName)}Target`]) {
      const template = this[`${templateName}Target`]
      const content = template.content.cloneNode(true)
      this.configContainerTarget.appendChild(content)

      // Animate in
      const firstChild = this.configContainerTarget.firstElementChild
      if (firstChild) {
        firstChild.style.opacity = '0'
        firstChild.style.transform = 'translateY(-10px)'
        requestAnimationFrame(() => {
          firstChild.style.transition = 'all 0.2s ease'
          firstChild.style.opacity = '1'
          firstChild.style.transform = 'translateY(0)'
        })
      }
    }
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
}
